module.exports = __webpack_public_path__ + "img/Desert-adventure-preview.ce7ec621.png";